import * as React from "react";
import { Info } from "lucide-react";

import { cn } from "@/lib/utils";

// ---------------------------------------------------------------------------
// UX-7 — «Nichts Ausgegrautes ohne Grund» (CLAUDE.md Prinzip 17).
// ---------------------------------------------------------------------------
// Der eine Satz, der neben einem gesperrten Knopf, Regler oder Schalter steht:
// WARUM er gerade nicht geht und was ihn freischaltet. Sichtbarer Text, kein
// Tooltip — am Handy gibt es kein Hover. Wo es geht, traegt der Satz gleich
// den Handgriff, der freischaltet (ein Knopf oder Link als Kind).
//
// Das gesperrte Element zeigt mit `aria-describedby={id}` auf den Satz, dann
// liest ihn auch der Bildschirmleser vor. Der Waechter
// `tests/ux7-kein-stummes-disabled.test.ts` erkennt den Satz an diesem Bauteil.

export interface SperrGrundProps extends React.HTMLAttributes<HTMLParagraphElement> {
  /** Ohne Symbol — fuer enge Stellen (Tabellenzelle, Menuezeile). */
  ohneSymbol?: boolean;
}

export function SperrGrund({ ohneSymbol = false, className, children, ...rest }: SperrGrundProps) {
  return (
    <p
      data-sperr-grund=""
      className={cn("flex items-start gap-1.5 text-xs text-muted-foreground", className)}
      {...rest}
    >
      {ohneSymbol ? null : <Info className="mt-0.5 size-3 shrink-0" aria-hidden="true" />}
      <span>{children}</span>
    </p>
  );
}
